/* eslint-disable */
import { withStyles, Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import get from 'lodash/get';
import Spinner from 'Components/Spinner/Spinner.component';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import isToday from 'date-fns/is_today';
import cn from 'classnames';
import { compose } from 'recompose';
import withServices from '../../Contexts/Services/WithServices.context';
import { UI_ORDER_DETAIILS_TRUCK_PANE_TRUCKS_ON_MAP_DIALOG_OPEN, UI_TRUCKS_ON_MAP_DIALOG_CLOSE } from '../../State/Store/UI/UI.types';
import { ORDER_STATUS_NEW, ORDER_STATUS_TO_BE_CONFIRMED, ORDER_STATUS_CANCELLED } from '../../Constants/Order/Order.constants';
import orderConcreteDeliveriesStatus from '../../State/Store/Orders/Selectors/OrderConcreteDeliveriesStatus.selector';
import orderItemSelector from '../../State/Store/Orders/Selectors/OrderItem.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import TrucksExpandableSection from '../TrucksExpandableSection/TrucksExpandableSection.component';
import orderConcreteDeliveriesStyles from './Trucks.component.styles';
import { ReduxRoot, DeliveryDetailOutter } from 'types/ReduxStore';
import MapIcon from '@material-ui/icons/Map';
import { Order } from 'types/Order';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import TrucksMapDialog from '../TrucksMapDialog/TrucksMapDialog.component';

interface Props {
  orderId: string;
}

interface InjectedProps {
  services: any;
  classes: any;
  selectedOrderLoading: boolean;
  currentDeliveryDetails: any;
  actions: any;
}

const TrucksComponent = (props: Props & InjectedProps) => {
  const { orderId, currentDeliveryDetails, selectedOrderLoading, services, classes, actions } = props;

  const [mapViewOpen, setMapViewOpen] = useState(false);

  const currentOrder: Order = useSelector((root: ReduxRoot) => root.orders.entities[orderId]);

  const openMapView = () => {
    actions.uiTriggered({ type: UI_ORDER_DETAIILS_TRUCK_PANE_TRUCKS_ON_MAP_DIALOG_OPEN });
    setMapViewOpen(true);
  };

  const closeMapView = () => {
    actions.uiTriggered({ type: UI_TRUCKS_ON_MAP_DIALOG_CLOSE });
    setMapViewOpen(false);
  };

  const renderLoader = () => {
    if (selectedOrderLoading) {
      return <Spinner loaderStyles={classes.trucksSpinner} />;
    }
    return (
      <Button
        data-testid="order-details-map-view-button"
        className={cn(classes.viewMap, classes.boxShadow0)}
        variant="contained"
        size="small"
        color="primary"
        onClick={openMapView}
      >
        <MapIcon className={classes.iconLeft} />
        Map View
      </Button>
    );
  };

  const renderError = () => {
    return (
      <Grid container>
        <Grid item>
          <Typography variant="body1">Something went wrong...</Typography>
        </Grid>
      </Grid>
    );
  };

  const hasViewLoad =
    isToday(currentOrder.summary.startTime.replace(`.`, `:`)) &&
    currentOrder.summary.status !== ORDER_STATUS_TO_BE_CONFIRMED &&
    currentOrder.summary.status !== ORDER_STATUS_NEW &&
    currentOrder.summary.status !== ORDER_STATUS_CANCELLED;

  if (!currentDeliveryDetails || !hasViewLoad) {
    return null;
  }
  const { error } = currentDeliveryDetails || {};
  const isEmptyOrder = isEmpty(get(currentDeliveryDetails, `data.orders`));
  const isError = !selectedOrderLoading && (error || isEmptyOrder);
  if (isError) {
    return renderError();
  }
  return (
    <React.Fragment>
      <Grid container className={classes.renderTrucksContainer}>
        <Grid item xs={12}>
          {renderLoader()}
          {!isEmptyOrder && (
            <Grid container item justify="space-between" spacing={2}>
              <Grid item xs={12}>
                <TrucksExpandableSection onOpenMap={openMapView} currentDeliveryDetails={currentDeliveryDetails} currentOrder={currentOrder} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <TrucksMapDialog open={mapViewOpen} onClose={closeMapView} currentOrder={currentOrder} />
    </React.Fragment>
  );
};

const OrderConcreteDeliveries = compose<Props & InjectedProps, Props>(
  withServices,
  withWidth(),
  withRouter,
  withStyles(themeCreateInjectableStyles(orderConcreteDeliveriesStyles) as any, { withTheme: true }),
  connect(
    () => (state, ownProps) => {
      const { orderId, services } = ownProps as any;
      const orderEntitySelector = orderItemSelector(orderId);
      const currentOrder = orderEntitySelector(state);
      const { summary } = currentOrder || {};
      const { orderCode, orderLine } = summary || {};
      const status = `DELIVERED,INTRANSIT,SCHEDULED`;
      const statusId = services.orderService.getStatusId({ orderCode, orderLine, status }).replace(/\s/g, '');
      const orderConcreteDeliveriesStatusSelector = orderConcreteDeliveriesStatus(statusId);
      const currentDeliveryDetails = orderConcreteDeliveriesStatusSelector(state);
      const { loading } = currentDeliveryDetails || {};
      return {
        currentDeliveryDetails,
        selectedOrderLoading: loading,
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(TrucksComponent);

export default OrderConcreteDeliveries;
